export default __webpack_public_path__ + "static/media/DentistCoinWhitePaper.b6376647.pdf";